<template>
  <footer class="footer">
    <div class="container">
      <div class="tborder"></div>
      <div class="row">
        <div class="col-12 col-md-3 text-center">
          <div class="copyright logo">
            <a href="#" class="logo__link">
              <img :src="logo" alt="Logo Arus" class="logo__img">
            </a>
            <p class="copyright__text">&copy; 2018, ARUS AG. All rights reserved</p>
          </div>
        </div>
        <div class="col-12 col-md-2 text-center">
          <div class="quick-links">
            <h3 class="quick-links__subtitle subtitle">
              Quick Links
            </h3>
            <ul class="quick-links__list list">
              <li class="list__item">
                <a href="#" class="list__link">
                  Arus Exchange
                </a>
              </li>
              <li class="list__item">
                <a href="#" class="list__link">
                  Support
                </a>
              </li>
              <li class="list__item">
                <a href="#" class="list__link">
                  Join Us
                </a>
              </li>
            </ul>
            <a href="#" class="quick-links__link">Privacy Policy</a>
          </div>
        </div>
        <div class="col-12 col-md-3 text-center">
          <div class="contacts">
            <h3 class="contacts__subtitle subtitle">
              Contact Us
            </h3>
            <ul class="contacts__list list">
              <li class="list__item">
                <a href="https://goo.gl/maps/YkceUwyru5g4yJhR9" class="list__link" target="_blank">
                  <img :src="geo" alt="Geo Pin"> Schützenstrasse 18 8808 Pfäffikon, Schwyz Switzerland
                </a>
              </li>
              <li class="list__item">
                <a href="tel:+41(0)796955128" class="list__link" target="_blank">
                  <img :src="phone" alt="Phone"> +41(0)796955128
                </a>
              </li>
            </ul>
            <a href="#" class="contacts__link">Terms and Conditions</a>
          </div>
        </div>
        <div class="col-md-3 offset-md-1 hide">
          <div class="symbol">
            <img :src="symbol" alt="Symbol">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import symbol from './../../assets/images/icon/symbol.svg'
  import phone from './../../assets/images/icon/phone.svg'
  import geo from './../../assets/images/icon/Geo.svg'
  import logo from './../../assets/images/icon/logo.svg'
  export default {
    name: 'Footer',
    data: function () {
      return {
        symbol,
        phone,
        geo,
        logo
      }
    }
  };
</script>

<style scoped>

</style>
